import { createAction, props } from '@ngrx/store';

import { RankingListEntity } from '../components/ranking-list/ranking-list.entity';

export enum RankingActions {
	InitRankingList = '[Ranking] get ranking list',
	RefreshRankingList = '[BE][Ranking] refresh Ranking list',
	FetchRankingListFail = '[BE][Ranking] fetch Ranking list fail',
	FetchRankingListSuccess = '[BE][Ranking] fetch Ranking list success',
	NavigateToRankingRoute = '[Ranking] navigate to Ranking route',
	NavigateToRankingCreateRoute = '[Ranking] navigate to Ranking create route',
	OpenDeleteConfirmationPopup = '[Ranking] open delete confirm popup',
	OpenDuplicateConfirmationPopup = '[Ranking] open duplicate confirm popup',
	DeleteRanking = '[Ranking] delete ranking',
	DeleteRankingFail = '[BE][Ranking] delete ranking fail',
	ToggleRankingStatus = '[Ranking] toggle ranking status',
	DuplicateRanking = '[Ranking] duplicate ranking',
	DuplicateRankingFail = '[BE][Ranking] duplicate ranking fail',
}

export const initRankingList = createAction(RankingActions.InitRankingList);

export const refreshRankingList = createAction(
	RankingActions.RefreshRankingList
);

export const fetchRankingListSuccess = createAction(
	RankingActions.FetchRankingListSuccess,
	props<{ rankingList: RankingListEntity }>()
);

export const fetchRankingListFail = createAction(
	RankingActions.FetchRankingListFail,
	props<{ error: unknown }>()
);
export const navigateToRanking = createAction(
	RankingActions.NavigateToRankingRoute,
	props<{ id: number }>()
);
export const navigateToRankingCreate = createAction(
	RankingActions.NavigateToRankingCreateRoute
);

export const openDeleteConfirmationPopup = createAction(
	RankingActions.OpenDeleteConfirmationPopup,
	props<{ rankingId: Array<number>; rankingLabel: string }>()
);

export const openDuplicateConfirmationPopup = createAction(
	RankingActions.OpenDuplicateConfirmationPopup,
	props<{ rankingId: Array<number>; rankingLabel: string }>()
);
export const deleteRanking = createAction(
	RankingActions.DeleteRanking,
	props<{ rankingId: number }>()
);

export const duplicateRanking = createAction(
	RankingActions.DuplicateRanking,
	props<{ rankingId: number }>()
);

export const deleteRankingFail = createAction(RankingActions.DeleteRankingFail);
export const duplicateRankingFail = createAction(
	RankingActions.DuplicateRankingFail
);

export const toggleRankingStatus = createAction(
	RankingActions.ToggleRankingStatus,
	props<{ rankingId: number; isActive: boolean }>()
);
